import { brandingConfig } from '@/config/branding';

export const buildLogoUrl = (logo: string | undefined, origin?: string): string => {
  const resolved = logo || brandingConfig.logo;
  // Incomplete/neutral partner brand: no logo → empty, not `${origin}/` (broken <img>).
  if (!resolved) return '';
  if (resolved.startsWith('http://') || resolved.startsWith('https://')) {
    return resolved;
  }
  const base =
    origin ??
    (typeof window !== 'undefined'
      ? window.location.origin
      : import.meta.env.VITE_CRM_URL || brandingConfig.appUrl || 'https://app.tagada.io');
  return `${base}${resolved.startsWith('/') ? '' : '/'}${resolved}`;
};
